/**
 * Created by shubham on 16/4/18.
 */

import { NgModule} from '@angular/core';
import { MaterialModule,MdTabsModule } from '@angular/material';
import { Http} from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RequestRoutingModule } from './view-request-routing.module';
import { ApproveRejectRequestModule } from '../approve-reject-request/approve-reject-request.module';
import { ViewRequestComponent } from './view-request.component';
import { ViewPartnersRequestComponent } from './viewPartners/viewPartners.component';
import { ViewSubUsersRequestComponent } from './viewSubUsers/viewSubUsers.component';
import { ViewApplicationRequestComponent } from './viewApplicationRequest/viewApplicationRequest.component';
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { TranslateModule,TranslateLoader,TranslateStaticLoader } from 'ng2-translate';
import { APPCONFIG } from '../config';

@NgModule({
    imports: [
        MaterialModule,
        MdTabsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RequestRoutingModule,
        AngularMultiSelectModule,
        ApproveRejectRequestModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            //useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
            useFactory: (http: Http) => new TranslateStaticLoader(http, APPCONFIG.URL+APPCONFIG.translationUrl, '?v='+APPCONFIG.translationVersion),
            deps: [Http]
        })
    ],
    declarations: [
        ViewRequestComponent,
        ViewPartnersRequestComponent,
        ViewSubUsersRequestComponent,
        ViewApplicationRequestComponent
    ],
    exports: [

    ]
})

export class ViewRequestModule {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewRequest/view-request.module.ts